// extracted by mini-css-extract-plugin
export var base = "_1z-0";
export var updateBanner = "_1z-1";